import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { PageContainer } from '../../../components/pageContainer/PageContainer';
import { Panel } from '../../../components/panel/Panel';
import { getFeatureFlags } from '../../featureFlags/featureFlagActionCreator';
import { useAuthSelector } from '../../auth/authSlice';
import styles from '../FeedList.module.scss';

// Shown when the feature-flags request failed, so we cannot tell whether the
// feed is enabled. Redirecting here would look identical to a broken link —
// which is exactly how the original /news bug got reported — so say what
// happened and offer a retry instead.
//
// Second argument to t() is the fallback: these keys are served from the API's
// Translations table, and a missing row would otherwise render the raw key.
export const FeedUnavailable: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const authUserId = useAuthSelector(state => state.authUser?.Id);

    return (
        <PageContainer>
            <Panel>
                <div className={styles.emptyState} role="alert" data-testid="feed-unavailable">
                    <h2>{t('Feed.UnavailableTitle', 'This page is unavailable right now')}</h2>
                    <p>
                        {t(
                            'Feed.UnavailableBody',
                            'We could not load this page. Check your connection and try again.'
                        )}
                    </p>
                    <Button
                        primary
                        onClick={() => dispatch(getFeatureFlags(authUserId))}
                        content={t('Feed.Retry', 'Try again')}
                    />
                </div>
            </Panel>
        </PageContainer>
    );
};
